import { CmmsIntegrationPanel } from "../components/CmmsIntegrationPanel";

/**
 * Standalone page for the CMMS capability, used by the
 * /capabilities/cmms-integration deep-link route.
 *
 * The primary entry point is the Integrations accordion on the Marketplace home
 * page, which opens the same panel in a right-side drawer. This page exists so
 * another AssetWatch app can link straight to the capability (epic Scenario 4)
 * without routing through the home page first.
 */
export function CmmsIntegrationScreen() {
  return <CmmsIntegrationPanel />;
}
